import { type ReactElement } from 'react';

import { useAutosaveEnabledStore } from '@/features/patient-record/lib/autosaveEnabled';

import { AutosaveIconToggle } from './AutosaveIconToggle';

/**
 * PTV2-1327 — the patient-record autosave on/off control, bound to the single global
 * {@link useAutosaveEnabledStore} (the same setting the pedigree toolbar's toggle drives). Renders the
 * shared {@link AutosaveIconToggle} so it matches the pedigree.
 */
export function AutosaveToggle(): ReactElement {
  const enabled = useAutosaveEnabledStore((s) => s.enabled);
  const setEnabled = useAutosaveEnabledStore((s) => s.setEnabled);
  return <AutosaveIconToggle enabled={enabled} onToggle={setEnabled} />;
}
